<template>
    <div
        class="flex h-screen overflow-hidden drafting-page-container"
    >
        <div v-if="!hideNavBar" class="flex flex-shrink-0">
            <NavBarV2 />
        </div>
        <div class="flex-1 overflow-y-auto">
            <router-view />
        </div>
        <AdminFloatingBar />
        <ProCreditsLimitModal />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import NavBarV2 from '@/components/Nav/NavBarV2.vue';
// import NavBarV1 from '@/components/Nav/NavBarV1.vue';
import AdminFloatingBar from '@/components/AdminFloatingBar.vue';
import ProCreditsLimitModal from '@/features/drafting/components/ProCreditsLimitModal.vue';
import { useAISettings } from '@/features/ai-settings';

// 预加载AI设置
const { loadSettings } = useAISettings();
const route = useRoute();
const hideNavBar = computed(() => route.meta.hideNavBar === true);

onMounted(() => {
    // 应用启动时加载AI设置，提前获取用户偏好
    loadSettings().catch((err) => {
        console.warn('Failed to preload AI settings:', err);
        // 失败不影响应用正常运行，会使用默认值
    });
});
</script>

<style lang="scss">
.drafting-page-container {
    &.anonymous {
        .patent-drafting-page {
            height: calc(100vh - 65px); // 减去顶部提示栏高度
        }
    }
}
</style>
